<div class="table-responsive" #scrollContainer>
    <table class="table simple-table" tabindex="0" (keydown)="_onKeydown($event)">
        <thead>
            <tr *ngIf="inputHeaderList">
                <th *ngIf="inputHasCheckboxes" width="40px">
                    <terra-checkbox
                        #viewChildHeaderCheckbox
                        (ngModelChange)="_onHeaderCheckboxChange()"
                        [ngModel]="_headerCheckbox.checked"
                        [isIndeterminate]="_headerCheckbox.isIndeterminate"
                    >
                    </terra-checkbox>
                </th>
                <th
                    *ngFor="let header of inputHeaderList"
                    width="{{ header.width }}"
                    [tcTooltip]="header.tooltipText"
                    [placement]="header.tooltipPlacement"
                    [ngStyle]="{ 'text-align': _getTextAlign(header) }"
                >
                    <span>{{ header.caption }}</span>
                </th>
            </tr>
        </thead>
        <tbody [class.highlighting]="inputUseHighlighting">
            <tr
                *ngFor="let row of inputRowList"
                [ngClass]="row.textColorCss"
                [ngStyle]="{ 'background-color': row.backgroundColor }"
                [class.isActive]="row === inputHighlightedRow"
                [class.disabled]="row.disabled"
                (click)="_onRowClick(row)"
            >
                <td *ngIf="inputHasCheckboxes" width="40px" (click)="_onCheckboxClick($event)">
                    <terra-checkbox
                        [ngModel]="row.selected"
                        [inputIsDisabled]="row.disabled"
                        (ngModelChange)="_onRowCheckboxChange(row)"
                    >
                    </terra-checkbox>
                </td>
                <ng-container *ngFor="let cell of row.cellList; let i = index">
                    <td
                        width="{{ inputHeaderList[i].width }}"
                        [tcTooltip]="cell.tooltipText"
                        [placement]="cell.tooltipPlacement"
                        [ngStyle]="{ 'text-align': _getTextAlign(inputHeaderList[i]) }"
                    >
                        <span [ngClass]="cell.icon"></span>
                        <span [innerHTML]="cell.caption"></span>
                        <div
                            class="btn-group"
                            *ngIf="cell.buttonList"
                            [ngClass]="{ 'float-right': cell.buttonListAlignRight }"
                        >
                            <ng-container *ngFor="let button of cell.buttonList">
                                <terra-button
                                    *ngIf="!button.isHidden"
                                    (outputClicked)="button.clickFunction($event)"
                                    [inputIcon]="button.icon"
                                    [inputIsDisabled]="button.isDisabled || row.disabled"
                                    [inputTooltipPlacement]="button.tooltipPlacement"
                                    [inputCaption]="button.caption"
                                    [inputIsSmall]="true"
                                    [inputTooltipText]="button.tooltipText"
                                >
                                </terra-button>
                            </ng-container>
                        </div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </table>
</div>
